import React from "react";
import axios from 'axios';
import { axiosBaseURL, axiosDelay } from '../../config/config';

import {
	CONFIG_DATA_PENDING
	,CONFIG_DATA_FULFILLED
	,CONFIG_DATA_REJECTED
} from "./configTypes";

import {
	dataAdd
	,dataRebuildFieldAliasLookup
} from "../data/dataActions";

export function configLoad() {
	return (dispatch, getState) => {

		dispatch({
			type: CONFIG_DATA_PENDING,
			payload: null
		});

		setTimeout(function () {
			const instance = axios.create({
				baseURL: axiosBaseURL()
			});

			// Here we pass a date time stamp to ensure the latest config is always loaded
			instance
				//.get('config{0}.json?{1}'.format(slot, new Date().getTime()))
				.get('config.json?{0}'.format(new Date().getTime()))
				.then(function (response) {
					const configData = response.data;

					console.log(
					  '================================CONFIG===========================',
					  configData
					);

					// Hydrate Data Sources
					if (response.data) {
						// console.log(environment.dataSources);
						for (let s = 0; s < response.data.dataSources.length; s++) {
							const dataSource = response.data.dataSources[s];
							dispatch(dataAdd(dataSource.name, dataSource.source, dataSource.fields, dataSource.aliases, dataSource.formatters, dataSource.groupby, dataSource.orderby, dataSource.listeners, dataSource.routes, dataSource.roles, dataSource.requireWhereClause, dataSource.includeInBulkRequest, dataSource.includeBaselineResults, dataSource.loadOnStartup, dataSource.enhanced));
						}

						// Rebuild the field/alias lookup
						setTimeout(() => { dispatch(dataRebuildFieldAliasLookup()) } , 0);
					}

					// Store the configuration
					dispatch({type: CONFIG_DATA_FULFILLED, payload: configData});

					// // Now that config is process and data sources setup fire route change
					// setTimeout(() => {
					// 	dispatch(dataRouteChanged());
					// }, 1000);

				})
				.catch(function (error) {
					dispatch({type: CONFIG_DATA_REJECTED, payload: error});
				});
		}, JSON.parse(axiosDelay()));

	}
}

